import React from 'react';
import { Text, View } from '@coinscrap/webapp-core';

export const SectionTitle = ({ title, style, tooltip = false }) => {
	return (
		<View alignItemsStartSt style={style}>
			<View rowSt justifyStartSt>
				<Text headingSecondarySt textLeftSt>
					{title}
				</Text>{' '}
				{tooltip}
			</View>
		</View>
	);
};
